import ItemVM from './item-vm';
import MediaLibrary from 'libs/media-library';
import PortfolioModal from '../../portfolio/modal';

export default function (data, $el) {
  const self = this;
  self.$el = $el;
  self.savedAt = ko.observable();
  self.project = ko.observable();
  self.saving = ko.observable();
  self.user_slug = ko.observable();
  self.defaultNoticeOptions = {
    parentObject: '.instructor-edit--sidebar',
    method: 'append'
  };
  self.currentPage = ko.observable(0);

  self.preview = function() {
    self.save(true).done(() => {
      const response = new Kadenze.AjaxRequest({
        type: 'GET',
        url: this.project().show_url(),
        loadingIndicator: self.$el
      });

      response.done((response) => {
        new PortfolioModal().show(response);
      });
    });
  };

  self.showShareModal = function(item,event) {
    if (self.project().status() === 'draft')
      return;

    var params = {modal_title: 'Share Project', shareableObj: {id: self.project().id(), title: self.project().title(), description: self.project().description(), share_url: self.project().share_url(), user_id: self.project().user_id() }, emailShareCb: self.shareProject};
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.shareProject = function(item, emails) {
    // var request = new Kadenze.AjaxRequest({
    //   type: 'POST',
    //   url: Kadenze.Routes.share_user_portfolio_project_path(self.project().user_id(), self.project().id()),
    //   data: {emails: emails}
    // });

    // request.done(function(res) {
      console.log("This feature is not available for now.");
    // });

    // request.fail(function(xhr, status, msg) {
    //   if (xhr.responseJSON) {
    //     msg = xhr.responseJSON.message;
    //   }
    //   new Kadenze.Notice.error({message: msg});
    // });
  };

  self.updateProjectItemsFromLibrary = function(items) {
    // remove unselected items (add _destroy attribute)
    const stillSelected = ko.utils.arrayFilter(self.project().project_items(), function (_pItem) {
      return _.find(items, function (_i) {
        return _i.id() === _pItem.media_item.id() && _i.item_class() === _pItem.media_item.item_class();
      });
    });

    self.project().project_items.destroy(function(_pItem) {
      return !(_.contains(stillSelected, _pItem));
    });

    // only update the attributes we care about for existing items (file, meta, etc)
    // and add new items
    _.each(items, function(_i) {
      const found_item = ko.utils.arrayFirst(self.project().project_items(), function (_pItem) {
        return _pItem.media_item.id() === _i.id() && _pItem.media_item.item_class() === _i.item_class();
      });
      if (found_item) {
        found_item.media_item = _i;
      }
      else {
        const pItem = {
          title: ko.observable(_i.name()),
          caption: ko.observable(''),
          media_item: _i,
          order: ko.observable(self.project().project_items().length + 1),
          editing: ko.observable(false)
        };
        self.project().project_items.push(new ItemVM(pItem));
      }
    });
    self.save();
  };

  self.updateProjectThumbFromLibrary = function(items) {
    self.project().logo_path(items[0].file.url());
    self.save();
  };

  self.removeProjectThumb = function () {
    self.project().remove_logo(true);
    self.save();
  };

  self.cropProjectThumb = function () {
    Kadenze.Util.toDataURL(self.project().logo_path(), function (file) {
      Kadenze.UIUtil.showCropper(file, function (cropper) {
        var cropped = cropper.getCroppedCanvas().toDataURL();
        self.project().logo_data(cropped.replace(/^data:image\/\w+;base64,/, ''));
        self.save();
      }, {});
    });
  };

  self.showMediaLibrary = function() {
    // create array of project items that have been 'trashed' from the table
    const removedItems = _.compact(_.map(self.project().project_items(), function (pItem) {
      if (pItem._destroy) {
        return pItem.media_item;
      }
    }));
      // pass in the existing project item information
    const existingItems = _.map(self.project().project_items(), function (pItem) {
      return pItem.media_item;
    });
    const mediaLibrary = new MediaLibrary(self.updateProjectItemsFromLibrary, existingItems, removedItems);
    mediaLibrary.show();
  };

  self.showThumbnailLibrary = function() {
    // create array of project items that have been 'trashed' from the table
    const removedItems = [];
    // pass in the existing project item information
    const existingItems = [];
    const mediaLibrary = new MediaLibrary(self.updateProjectThumbFromLibrary, existingItems, removedItems, {
      maxItems: 1,
      fileType: 'Image'
    });
    mediaLibrary.show();
  };

  self.initProjectItemSortable = function() {
    if (self.project().id() && self.project().project_items().length > 0) {
      const url = Kadenze.Routes.sort_portfolio_project_portfolio_project_items_path(self.project().id());
      const $el = $('.display-table.sortable .display-table__body', '#js-pb-project-media');
      Kadenze.UIUtil.initSortable(url, $el, $('#js-project-items-table'), self.sortProjectItems);
    }
  };

  self.sortProjectItems = function(url, $el, $container) {
    const req = new Kadenze.AjaxRequest({
      url: url,
      type: 'POST',
      data: $el.sortable('serialize'),
      dataAsJSON: false,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      beforeSend: function (xhr, settings) {
        self.saving(true);
      },
      loadingIndicator: {
        container: $container
      },
    });

    req.fail(function(xhr, textstatus, message) {
      $el.sortable('cancel');
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: 'An unexpected error occurred while sorting. Please try again later.' }));
    });

    req.always(function(xhr, textStatus) {
      self.saving(false);
    });
  };

  self.deleteProjectItem = function(item) {
    Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('portfolio_project_item.delete.confirm'), function() {
      self.project().project_items.destroy(item);
      self.save();
    });
  };

  self.validate = function() {
    return [];
  };

  self.delete = function() {
    const removeFunc = function () {
      const url = Kadenze.Routes.user_portfolio_project_path(self.user_slug(), self.project().id());
      const request = new Kadenze.AjaxRequest({
        url: url,
        type: 'DELETE',
        loadingIndicator: {
          container: self.$el
        },
      });

      request.done(function (data) {
        new Kadenze.Notice.success({message: data.message});
        window.location = Kadenze.Routes.edit_user_registration_path(self.user_slug(), {edit: true});
      });

      request.fail(function (data) {
        new Kadenze.Notice.error({message: data.errors});
      });
    };

    Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('portfolio_project.delete.confirm'), function() {
      removeFunc();
    });
  };

  self.publish = function() {
    self.project().temp_status('published');
    const request = self.save();
    request.success(function(data, textStatus, xhr) {
      window.location = Kadenze.Routes.user_profile_path(self.user_slug(), {edit: true});
    });
  };

  self.unpublish = function() {
    self.project().temp_status('draft');
    self.save();
  };

  self.save = function(isAutoSave) {
    self.saving(true);
    let url = Kadenze.Routes.user_portfolio_projects_path(self.user_slug());
    let method = 'POST';
    if (self.project().id()) {
      url = Kadenze.Routes.user_portfolio_project_path(self.user_slug(), self.project().id());
      method = 'PATCH';
    }
    const data = {'portfolio_project': ko.mapping.toJS(self.project)};
    data.portfolio_project.portfolio_project_items_attributes = _.map(data.portfolio_project.project_items,
      function(pItem) {
        return {
          id: pItem.id,
          title: pItem.title,
          caption: pItem.caption,
          media_item_id: pItem.media_item_id || pItem.media_item.id,
          media_item_type: pItem.media_item_type || pItem.media_item.item_class,
          _destroy: pItem._destroy
        };
      }
    );

    delete data.portfolio_project.project_items;

    //convert dates
    if (!_.isEmpty(data.portfolio_project.project_date)) {
      data.portfolio_project.project_date_string = Kadenze.Util.getMomentDateFromObservable(self.project().project_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
      delete data.portfolio_project.project_date;
    }

    // handle for publishing
    data.portfolio_project.status = data.portfolio_project.temp_status;
    delete data.portfolio_project.temp_status;

    const onNoticeDismiss = function () {
      return setTimeout(function () {
        self.savedAt(new Date());
      }, 1000);
    };

    const request = new Kadenze.AjaxRequest({
      url: url,
      type: method,
      data: data,
      loadingIndicator: {
        container: self.$el
      },
      beforeSend: function (xhr, settings) {
        self.saving(true);
      }
    });

    request.done(function(data, textStatus, xhr) { //Success
      self.bindData(data.project);

      if(isAutoSave) {
        self.savedAt(new Date());
      }

      if(!isAutoSave) {
        new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: Kadenze.I18n.t('dict.save_success'), onDismiss: onNoticeDismiss }));
      }
    });

    request.error(function(xhr, textStatus, errorThrown) {
      let msg = 'An unknown error occurred. Please try again later';
      if (xhr.responseJSON && xhr.responseJSON.errors) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: msg }));
    });

    request.always(function(xhr, textStatus) {
      self.saving(false);
    });

    return request;
  };

  self.initUI = function() {
    self.initProjectItemSortable();
  };

  self.bindData = function(data) {
    const project_data = JSON.parse(data).project;
    const user_data = JSON.parse(data).user;

    const mapping = {
      'create': function (options) {
        const subMap = {
          'project_items': {
            'create': function (options) {
              const res = ko.mapping.fromJS(_.extend({}, options.data, {editing: false}));
              if (res.media_item.file) {
                res.media_item.file.thumb = ko.observable(ko.mapping.fromJS(res.media_item.file.thumb));
              }
              return new ItemVM(res);
            }
          }
        };
        return ko.mapping.fromJS(options.data, subMap);
      }
    };

    const mapped = ko.mapping.fromJS(_.extend(project_data, {
      remove_logo: false,
      temp_status: project_data.status
    }), mapping);
    self.project(mapped);
    self.project().project_date_string(self.project().project_date());

    self.savedAt(new Date());
    self.user_slug(user_data.slug);
  };

  const __construct = function(that) {
    self.bindData(data);
    self.media_types_count = ko.computed(function() {
      return _.countBy(self.project().project_items(), function(project_item) {
        if(!project_item._destroy){
          return project_item.media_item.type();
        }
      });
    });
    self.media_types_array = ko.computed(function() {
      const mappedArray = _.map(self.media_types_count(), function (v, k) {
        if (k !== 'undefined') {
          return {type: s.capitalize(k) + ' Files:', count: v};
        }
      });
      return _.compact(mappedArray);
    });
  }(this);
}

